var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgGavel(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M18.044.328c.422.469.422 1.172 0 1.594l7.406 7.406c.422-.422 1.125-.422 1.594 0 .422.469.422 1.172 0 1.594l-.797.797-4.453 4.453-.75.75c-.469.469-1.172.469-1.594 0-.422-.422-.469-1.078-.047-1.5l-7.406-7.453c-.469.422-1.125.375-1.547-.047a1.027 1.027 0 010-1.547l.75-.75 4.453-4.5.797-.797a1.104 1.104 0 011.547 0h.047zM16.45 3.516l-2.906 2.859 7.453 7.453 2.86-2.906-7.407-7.406zm-2.625 8.437l1.594 1.594-2.344 2.344.328.328c.61.562.61 1.547 0 2.11l-5.25 5.25c-.562.608-1.547.608-2.11 0l-2.249-2.25a1.445 1.445 0 010-2.11l5.25-5.25a1.445 1.445 0 012.11 0l.327.328 2.344-2.344zm-3.703 4.125L5.903 20.25l1.22 1.219 4.17-4.219-1.17-1.172z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgGavel);
export default ForwardRef;
